import { useNavigate } from "react-router";
import { deepLinks } from "../../navigation/deep-links";
import { Card } from "../../ui/card";
import { PageHeader } from "../../ui/page-header";
import { CustomerList } from "../components/CustomerList";

// `/analytics`: the area opens on the list of the customers that the server lets this staff member open, with a search field and "Show more", so a
// person who may open any customer can reach every one of them from here. Choosing a row opens the cockpit of that customer, and only then is an
// opening written to the audit trail.

export function AnalyticsLandingPage() {
  const navigate = useNavigate();
  return (
    <section aria-labelledby="page-title" className="grid gap-5">
      <PageHeader
        title="Analytics"
        titleId="page-title"
        eyebrow="Customer analytics"
        description="Choose a customer to look at their numbers. Every time you open a customer, it is written to the audit trail."
      />
      <Card className="rounded-2xl p-4">
        <CustomerList
          onPick={(customerId) => navigate(deepLinks.customerAnalytics(customerId))}
          size="page"
          idPrefix="analytics-landing"
        />
      </Card>
    </section>
  );
}
